import { useCallback, useEffect, useState } from "react";
import { API_BASE } from "@/config/links";

export const WEB_ID_KEY = "skz_web_id";

export function readWebId() {
  try {
    const id = window.localStorage.getItem(WEB_ID_KEY);
    return /^[0-9a-f]{32}$/.test(id || "") ? id : null;
  } catch {
    return null;
  }
}

export function saveWebId(id) {
  try {
    window.localStorage.setItem(WEB_ID_KEY, id);
  } catch {
    // приватный режим — работаем в рамках одной вкладки
  }
}

export function clearWebId() {
  try {
    window.localStorage.removeItem(WEB_ID_KEY);
  } catch {
    // приватный режим
  }
}

// Сессия живёт в httpOnly-куке, поэтому все запросы идут с credentials: "include".
export async function apiJson(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || `${path} ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export function logout() {
  // Fastify отвечает 400 на JSON-запрос без тела — шлём пустой объект.
  return apiJson("/api/web/auth/logout", { method: "POST", body: "{}" });
}

export function useMe() {
  const [state, setState] = useState({ loading: true, email: null, webId: null });

  const refresh = useCallback(async () => {
    try {
      const data = await apiJson("/api/web/auth/me");
      setState({ loading: false, email: data.email || null, webId: data.webId || null });
    } catch {
      setState({ loading: false, email: null, webId: null });
    }
  }, []);

  useEffect(() => {
    let alive = true;
    apiJson("/api/web/auth/me")
      .then((data) => {
        if (alive) setState({ loading: false, email: data.email || null, webId: data.webId || null });
      })
      .catch(() => {
        if (alive) setState({ loading: false, email: null, webId: null });
      });
    return () => {
      alive = false;
    };
  }, []);

  return { ...state, refresh, setEmail: (email) => setState((s) => ({ ...s, email })) };
}

export function shortEmail(email) {
  if (!email) return "";
  const [name, domain] = email.split("@");
  if (!domain) return email.slice(0, 14);
  return name.length > 10 ? `${name.slice(0, 9)}…@${domain}` : `${name}@${domain}`;
}
